import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  ActivateAuthenticatorRequestModel,
  ActivateAuthenticatorResponseModel,
  AuthenticatorCodeRequestModel,
  AuthenticatorCodeResponseModel,
  AuthenticatorKeyResponseModel,
  ForgotPasswordRequestModel,
  ForgotPasswordResponseModel,
  PermissionResponseModel,
  ResetPasswordRequestModel,
  ResetPasswordResponseModel,
  SignInRequestModel,
  SignInResponseModel,
  SignOutResponseModel,
  TokenResponseModel,
  VerifyAuthenticatorRequestModel,
  VerifyAuthenticatorResponseModel,
  VerifyResponseModel,
} from '../../models/identity/authentication.model';

import { Endpoint } from '../constants/endpoint';

@Injectable({ providedIn: 'root' })
export class AuthenticationFetchService {
  constructor(private _http: HttpClient) {}

  public signIn(data: SignInRequestModel): Observable<SignInResponseModel> {
    return this._http.post<SignInResponseModel>(
      Endpoint.Identity.Authentication.SignIn,
      data
    );
  }

  public authenticatorKey(): Observable<AuthenticatorKeyResponseModel> {
    return this._http.get<AuthenticatorKeyResponseModel>(
      Endpoint.Identity.Authentication.AuthenticatorKey
    );
  }

  public authenticatorCode(
    data: AuthenticatorCodeRequestModel
  ): Observable<AuthenticatorCodeResponseModel> {
    return this._http.post<AuthenticatorCodeResponseModel>(
      Endpoint.Identity.Authentication.AuthenticatorCode,
      data
    );
  }

  public verify(): Observable<VerifyResponseModel> {
    return this._http.get<VerifyResponseModel>(
      Endpoint.Identity.Authentication.Verify
    );
  }

  public token(): Observable<TokenResponseModel> {
    return this._http.get<TokenResponseModel>(
      Endpoint.Identity.Authentication.Token
    );
  }

  public permission(): Observable<PermissionResponseModel> {
    return this._http.get<PermissionResponseModel>(
      Endpoint.Identity.Authentication.Permission
    );
  }

  public forgotPassword(
    data: ForgotPasswordRequestModel
  ): Observable<ForgotPasswordResponseModel> {
    return this._http.post<ForgotPasswordResponseModel>(
      Endpoint.Identity.Authentication.ForgotPassword,
      data
    );
  }

  public resetPassword(
    data: ResetPasswordRequestModel
  ): Observable<ResetPasswordResponseModel> {
    return this._http.post<ResetPasswordResponseModel>(
      Endpoint.Identity.Authentication.ResetPassword,
      data
    );
  }

  public verifyAuthenticator(
    data: VerifyAuthenticatorRequestModel
  ): Observable<VerifyAuthenticatorResponseModel> {
    return this._http.post<VerifyAuthenticatorResponseModel>(
      Endpoint.Identity.Authentication.VerifyAuthenticator,
      data
    );
  }

  public activateAuthenticator(
    data: ActivateAuthenticatorRequestModel
  ): Observable<ActivateAuthenticatorResponseModel> {
    return this._http.post<ActivateAuthenticatorResponseModel>(
      Endpoint.Identity.Authentication.ActivateAuthenticator,
      data
    );
  }

  public signOut(): Observable<SignOutResponseModel> {
    return this._http.post<SignOutResponseModel>(
      Endpoint.Identity.Authentication.SignOut,
      null
    );
  }
}
